import React from "react";

export type SectionProps = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
  as?: "section" | "div";
  id?: string;
  hideHeader?: boolean;
};

export function Section({
  title,
  subtitle,
  children,
  className = "",
  as = "section",
  id,
  hideHeader = false,
}: SectionProps) {
  const Component = as;

  return (
    <Component id={id} className={className}>
      {!hideHeader && (
        <header className="section-header">
          <h2 className="section-title-quicksand">{title}</h2>
          {subtitle && <p className="section-subtitle">{subtitle}</p>}
        </header>
      )}
      <div className="section-content">{children}</div>
    </Component>
  );
}
